// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"253":"1c1f8b13","631":"e38c3a71","702":"013d5325","734":"3e8a4821","909":"4aaf14ef","924":"5af6455e"}[chunkId] + ".css";
};